<template>
  <div class="main-wrapper-container row-list-container publication-page">
    <header-title :main-title="mainTitle" :btn-info="btnInfo"/>
    <label class="publication-filter">Показать
      <select v-model="publicationFilter" @change="changePublicationFilter">
        <option v-for="filter in publicationFilters" :key="filter.value" :value="filter.value">{{ filter.title }}</option>
      </select>
    </label>
    <p v-if="loadError" class="publication-load-error" role="alert">{{ loadError }}</p>
    <template-pagination
        v-else
        @changePage="changePage"
        @changeValue="changeValueSearch"
        :is-loading="isLoadingItems"
        :active-page="pagination.page"
        :page-total="pagination.total"
    >
      <TableView
          :headers="headers"
          :items="academy"
          :search="search"
          :is-active-search="false"
          @edit="item => openEditAcademy(item.id)"
          @delete="item => openModalDeleteMaterial(item)"
          @change-page="page => console.log('page', page)"
          @search="item => console.log('search', item)"
      />
    </template-pagination>
  </div>
</template>

<script>
import HeaderTitle from "@/components/entities/HeaderTitle.vue";
import TemplatePagination from "@/components/entities/pagination/TemplatePagination.vue";
import paginationMixin from "@/mixins/pagination.mixin";
import RowItem from "@/components/entities/items/RowItem.vue";
import modalAgreement from "@/mixins/modals/modalAgreement";
import TableView from "@/components/shared/table/TableView.vue";

import {api} from "@/middleware/api";
import { PUBLICATION_FILTERS, publicationLabel, displayMoscow } from "@/services/publication-schedule.mjs";
import { adminListLoadError } from "@/services/admin-session.mjs";

export default {
  name: "AcademyPage",
  components: {TableView, RowItem, TemplatePagination, HeaderTitle},
  mixins: [paginationMixin, modalAgreement],
  data() {
    return {
      academy: [],
      publicationFilter: "published",
      publicationFilters: PUBLICATION_FILTERS,
      headers: [
        {text: 'Название', value: 'title'},
        {text: 'Описание', value: 'description', class: 'td-description'},
        {text: 'Дата публикации', value: 'publishedAt'},
        {text: 'Статус', value: 'publicationLabel'},
        {text: 'По расписанию', value: 'scheduledLabel'},
        {text: 'Тип', value: 'typeLabel'},
      ],
      isLoadingItems: false,
      mainTitle: 'Академия',
      btnInfo: {
        text: 'Добавить элемент',
        action: () => this.openCreateAcademy()
      },
      loadError: '',
      timer: null
    }
  },
  created() {
    this.fetchInfo();
  },
  computed: {
  },
  methods: {
    changePublicationFilter() { this.pagination.page = 1; this.fetchInfo(); },
    async fetchInfo() {
      this.loadError = '';
      this.isLoadingItems = true;
      this.IS_GLOBAL_LOADING(true)
      try {
        const { data } = await api.dashboard.adminAcademiesControllerFindAll({
          ...this.search !== ''
              ? { title: this.search }
              : {},
          publicationFilter: this.publicationFilter,
          limit: this.pagination.limit,
          offset: this.activeOffset
        })
        this.pagination.offset = data.offset;
        this.pagination.total = Math.ceil(data.total / this.pagination.limit)
        this.academy = data.items.map(item => ({
          ...item,
          typeLabel: item.type === 'COURSE' ? 'Курсы' : item.type === 'GUIDE' ? 'Гайды' : item.type,
          publicationLabel: publicationLabel(item),
          scheduledLabel: displayMoscow(item.publication?.scheduledAt),
          publishedAt: item.publishedAt ? this.formatDate(item.publishedAt) : "—"
        }));
      } catch (error) {
        this.academy = [];
        this.pagination.offset = 0;
        this.pagination.total = 0;
        this.loadError = adminListLoadError(error.response?.status, 'список Академии');
        if (this.loadError) this.alertError(this.loadError);
      } finally {
        this.isLoadingItems = false;
        this.IS_GLOBAL_LOADING(false)
      }
    },
    openCreateAcademy() {
      this.$router.push({
        name: 'academy-create'
      })
    },
    openEditAcademy(id) {
      this.$router.push({
        name: 'academy-edit',
        params: {
          id
        }
      })
    },
    async removeMaterial(item) {
      this.IS_GLOBAL_LOADING(true)
      await api.dashboard.adminAcademiesControllerRemove(item.id)
      this.academy = this.academy.filter(m => m.id !== item.id)
      this.IS_GLOBAL_LOADING(false)
    }
  }
}
</script>

<style scoped>
.publication-filter { display: flex; align-items: center; gap: 12px; margin: 16px 0; }
.publication-filter select { padding: 10px 16px; border: 1px solid #738a78; border-radius: 8px; background: white; }
.publication-load-error { margin: 24px 0; color: var(--color-red); }

</style>
